
// Greys out a pdp-group-swatch__item (with a diagonal cross, via CSS) when the
// size currently selected on this product is sold out on that swatch's product.
(function () {
  function getSizeOptionPosition() {
    var container = document.querySelector('[data-size-option-position]');
    if (!container) return -1;
    var position = parseInt(container.dataset.sizeOptionPosition, 10);
    return isNaN(position) ? -1 : position;
  }

  function getInitialSizeValue(position) {
    var container = document.querySelector(
      'variant-radios[data-size-option-position], variant-selects[data-size-option-position]'
    );
    if (!container) return null;

    var fieldset = container.querySelectorAll('.product-form__input')[position];
    if (!fieldset) return null;

    var checkedInput = fieldset.querySelector('input:checked');
    if (checkedInput) return checkedInput.value;

    var select = fieldset.querySelector('select');
    return select ? select.value : null;
  }

  function updateGroupSwatches(sizeValue) {
    if (!sizeValue) return;

    document.querySelectorAll('.pdp-group-swatch__item[data-size-availability]').forEach(function (item) {
      var availability;
      try {
        availability = JSON.parse(item.dataset.sizeAvailability);
      } catch (error) {
        return;
      }

      item.classList.toggle('sold-out', availability[sizeValue] === false);
    });
  }

  document.addEventListener('variantChange', function (event) {
    var position = getSizeOptionPosition();
    if (position < 0) return;

    var variant = event.detail && event.detail.variant;
    var sizeValue = variant && variant.options ? variant.options[position] : null;
    updateGroupSwatches(sizeValue);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var position = getSizeOptionPosition();
    if (position < 0) return;

    updateGroupSwatches(getInitialSizeValue(position));
  });
})();

// Shows the hovered (or keyboard-focused) swatch's colour name inline in its
// group heading ("Core: Dark Khaki") instead of a floating browser tooltip,
// restoring the selected colour's name when the pointer leaves.
(function () {
  function setHeadingName(link, name) {
    var list = link.closest('.pdp-group-swatches');
    if (!list) return;
    var heading = list.previousElementSibling;
    var nameSpan = heading && heading.querySelector('[data-swatch-group-name]');
    if (!nameSpan) return;
    nameSpan.textContent = name ? ': ' + name : '';
  }

  function getSwatchLink(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    var link = target.closest('.pdp-group-swatch__link');
    return link && link.dataset.swatchName ? link : null;
  }

  function onEnter(event) {
    var link = getSwatchLink(event);
    if (!link) return;
    setHeadingName(link, link.dataset.swatchName);
  }

  function onLeave(event) {
    var link = getSwatchLink(event);
    if (!link) return;
    if (event.relatedTarget && link.contains(event.relatedTarget)) return;
    var list = link.closest('.pdp-group-swatches');
    var heading = list && list.previousElementSibling;
    var nameSpan = heading && heading.querySelector('[data-swatch-group-name]');
    if (!nameSpan) return;
    nameSpan.textContent = nameSpan.dataset.defaultName ? ': ' + nameSpan.dataset.defaultName : '';
  }

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('focusout', onLeave);
})();
